import applogger from '@applogger'
let pageMixin
let asyncLoader

// eslint-disable-next-line no-undef
if (APPSETTINGS.DataStore.store === 'ichabodcms') {
  asyncLoader = ({ store, route, router }) => {
  }
  pageMixin = {
  }
}
else {
  asyncLoader = ({ store, route, router }) => {
    if (!route) {
      return Promise.resolve(false)
    }
    applogger.debug('generic-node asyncData starting')
    const __loader = () => store.dispatch('node/load', {nid: route.path, cacheOptions: {scope: 'global'}})
      .then(node => {
        let p = []
        const blobsToLoad = [
          `page-blob-top--node-${node.nid}`,
          `page-blob-bottom--node-${node.nid}`
        ]
        p.push(store.dispatch('blob/loadgroup', {blobIDs: blobsToLoad, cacheOptions: { scope: 'global', ttl: 3600 * 12 }}))

        return Promise.all([node, Promise.all(p)])
      })
      .then(([node, _loaders]) => {
        applogger.debug(`generic-node asyncData Complete - ${node.title}`)
        if (node.path && node.path !== `node/${node.nid}`) {
          router.replace(`/${node.path}`)
        }
        else {
        // Attempt to execute the async Data on the component that will be finally used.
          let type = `page-content-type-${node.type}`
          let loaderFunc = router.app.$options.components[type]
          let loader = null
          if (loaderFunc) {
            loader = loaderFunc.call()
          }
          if (loader) {
            return loader.component.then(component => {
              if (Object.prototype.hasOwnProperty.call(component.default, 'asyncData') && typeof component.default.asyncData === 'function') {
                return component.default.asyncData.call(null, {store, route, router})
              }
            })
          }
          else {
          // We could not locate the component that would be required to render the page.
            store.commit('SET_PAGE_SETTING', { key: 'error', value: 404 })
          }
        }
      })
      .catch(err => {
        applogger.error(`Generic Node: ${err.message}`)
        if (err && err.response) {
          switch (err.response.status) {
          case 403:
            store.commit('SET_PAGE_SETTING', { key: 'error', value: 403 })
            break
          case 404:
            store.commit('SET_PAGE_SETTING', { key: 'error', value: 404 })
            break
          default:
            store.commit('SET_PAGE_SETTING', { key: 'error', value: 500 })
            break
          }
        }
        else {
          store.commit('SET_PAGE_SETTING', { key: 'error', value: 500 })
        }
      })

    return store.dispatch('promisePool', {
      name: `generic-node-common--${route.path}`,
      resolve: __loader
    })
  }
  pageMixin = {
    computed: {
      componentName: function() {
        return `page-content-type-${this.node.type}`
      },
      node: function() {
        return this.$store.getters['node/getByNID'](this.$route.params.nid)
      }
    }
  }
}

export default pageMixin
export {
  pageMixin,
  asyncLoader
}
